<template>
  <q-page padding>
    <MultiViewLayout :onBackClick="onBackClick">

      <!-- Title -->
      <template v-slot:title>{{ t('settings') }}</template>

      <!-- Heading Text/Content -->
      <template v-slot:heading>{{ t('settings_help_support') }}</template>

      <!-- View Unique Content -->
      <template v-slot:default>

        <!-- Support Content -->
        <div class="row">
            <div class="col">
                <pre class="support-info-text mb-60">{{formattedPolicyDescription}}</pre>
                <!-- Visit Support Button -->
                <p class="text-center">
                    <zbm-btn :color="$zb.enums.ButtonStdColorEnum.accentText" :height="$zb.enums.ButtonHeightEnum.lg"
                             href="http://support.zbmymobilitysolutions.com/" :label="t('settings_help_site')" target="_blank" />
                </p>
            </div>
        </div>
      </template>
    </MultiViewLayout>
  </q-page>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { handleApiRequest } from 'src/api/handleApiRequest';
import { getLocalizedPolicy } from 'src/api/endpoints/registrationWeb';
import { UserPolicyType, ClientFeatureType } from 'src/constants/enums';
import MultiViewLayout from 'src/components/layouts/MultiViewLayout.vue';
import { type UserPolicy } from 'src/types/webContracts';
import { useQuasar } from 'quasar';
import {useI18n} from 'vue-i18n';
import { useSessionStore } from '@/store';

const {t}= useI18n();
const $q = useQuasar()
const router = useRouter();
const sessionStore = useSessionStore();
const isHealthCareLiveEnabled = computed(() => 
  sessionStore.user?.clientFeatures?.includes(ClientFeatureType.HealthCareLive) ?? false
);

const policyType = computed(() => 
  isHealthCareLiveEnabled.value 
    ? UserPolicyType.UserPolicyHealthCareLiveSupport 
    : UserPolicyType.UserPolicySupport
);

const localizedPolicy = ref<UserPolicy>({
  id: 0,
  header: '',
  description: '',
  type: '',
  dismissed: false,
  consented: false
});

const formattedPolicyDescription = computed(() => localizedPolicy.value.description);

onMounted(async () => {
  const response = await handleApiRequest(() =>
    getLocalizedPolicy(policyType.value), null, $q
  );
  if (response?.result) {
    localizedPolicy.value = response.result;
  }
});


function onBackClick() {
  router.push({ name: 'Settings' });
}
</script>

<style lang="scss" scoped>
.support-info-text {
  word-wrap: break-word;
}
</style>
